var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04_\u6302\u53F7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,36h8v8a2,2,0,0,0,2,2h0a2,2,0,0,0,2-2V36h8a2,2,0,0,0,2-2h0a2,2,0,0,0-2-2H34V24a2,2,0,0,0-2-2h0a2,2,0,0,0-2,2v8H22a2,2,0,0,0-2,2h0A2,2,0,0,0,22,36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58,12H44V10a2,2,0,0,0-2-2h0a2,2,0,0,0-2,2v2H24V10a2,2,0,0,0-2-2h0a2,2,0,0,0-2,2v2H6a2,2,0,0,0-2,2V54a2,2,0,0,0,2,2H58a2,2,0,0,0,2-2V14A2,2,0,0,0,58,12ZM56,52H8V16H56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/registration.c5f23344.svg";
export { ForwardRef as ReactComponent };